import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import FullLogo from './FullLogo'
import SignInMessage from './SignInMessage'
import CustomTextField from '../CustomTextField'
import CustomeButton from '../CustomeButton'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import LockIcon from '@mui/icons-material/Lock'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const ForgotPasswordSection = () => {
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: {
      email: '',
      aadhar: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
      aadhar: Yup.string()
        .matches(/^[0-9]{12}$/, 'AADHAAR number must be 12 digits')
        .required('AADHAAR number is required'),
    }),
    onSubmit: (values) => {
      navigate('/')
    },
  })

  return (
    <Box
      component='form'
      onSubmit={formik.handleSubmit}
      sx={{
        flex: 1,
        padding: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      {/* Full Logo  */}
      <Box sx={{ marginBottom: 4 }}>
        <FullLogo />
      </Box>

      <Typography variant='h5' sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Forgot your <span style={{ color: '#F6764E' }}>Password</span>
      </Typography>

      <SignInMessage
        text='Please enter your registered email address for password reset link'
        color='black'
      />

      <CustomTextField
        icon={MailOutlineIcon}
        placeholder='Email'
        type='text'
        name='email'
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
        sx={{ width: '70%', marginBottom: 2 }}
      />

      <CustomTextField
        icon={LockIcon}
        placeholder='AADHAAR No'
        type='text'
        name='aadhar'
        value={formik.values.aadhar}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.aadhar && Boolean(formik.errors.aadhar)}
        helperText={formik.touched.aadhar && formik.errors.aadhar}
        sx={{ width: '70%', marginBottom: 2 }}
      />

      <CustomeButton type='submit' text='Send reset link' width='40%' />
      <Link
        onClick={() => navigate('/')}
        underline='always'
        sx={{
          fontFamily: 'Work Sans',
          fontWeight: 500,
          textAlign: 'center',
          color: 'black',
          fontSize: '0.95rem',
          textDecorationColor: 'black',
          cursor: 'pointer',
        }}>
        Click here to Login
      </Link>
    </Box>
  )
}

export default ForgotPasswordSection
